module.exports = __webpack_public_path__ + "img/kleisma1-m@1.a5b00078.jpg";